import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-hot-toast";

// Guards customer-only pages (cart, wishlist, profile, orders, etc.) against
// being opened directly by URL while logged out — those pages otherwise
// only checked auth inside click handlers, which a typed-in URL bypasses.
const RequireAuth = ({ children }) => {
  const isLoggedIn = !!localStorage.getItem("authToken");

  useEffect(() => {
    if (!isLoggedIn) {
      toast("Please log in to access this page.", {
        id: "login-required-page",
        icon: "ℹ️",
      });
    }
  }, [isLoggedIn]);

  if (!isLoggedIn) return <Navigate to="/home" replace />;
  return children;
};

export default RequireAuth;
